import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import DownTrianglePointerSvg from '@/assets/DownTrianglePointer.svg';

const DownTrianglePointer = ({ size, variant, className }: IconProps) => (
  <img
    src={DownTrianglePointerSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default DownTrianglePointer;
